// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export async function GetInvoiceDetailsApi(invoiceNumber: string): Promise<Blob> {
    const response = await fetch(`/api/psc/invoice-history/download-pdf/${invoiceNumber}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/pdf",
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch PDF: ${response.statusText}`);
    }

    const pdfBlob = await response.blob();
    return pdfBlob;
}
